<template>
    <article>
        <h2 class="text-white font-bold text-[15px]">{{ training.title }}</h2>

        <div class="flex justify-start">
            <div class="max-w-[158px] h-[100px] pr-3">
                <iframe class="w-full h-full object-contain" :src="training.video" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen=""></iframe>
            </div>
            <div class="flex flex-col justify-around">
                <p class="text-white text-xs">{{ training.description }}</p>

                <QuizControls :training="training" :linkTag="true"/>
            </div>
        </div>
    </article>
</template>

<script>
import QuizControls from '@/Components/QuizControls.vue'

export default {
    components: {
        QuizControls
    },
    props: {
        training: Object
    },
}
</script>